import { render, staticRenderFns } from "./PC-item-container.vue?vue&type=template&id=1b218cbe&scoped=true"
import script from "./PC-item-container.vue?vue&type=script&lang=js"
export * from "./PC-item-container.vue?vue&type=script&lang=js"
import style0 from "./PC-item-container.vue?vue&type=style&index=0&id=1b218cbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b218cbe",
  null
  
)

export default component.exports